import { Button } from '@chakra-ui/react';
import { useUserContext } from 'providers/useUserContext';

export function Logout() {
  const { logout } = useUserContext();

  return <Button onClick={logout}>Logout</Button>;
}
